import styled from '@emotion/styled'
import { UltyInputStep } from '@ulty/ulty-ui'
import { Button, Icon } from 'semantic-ui-react'
import { useContext, useState } from 'react'
import { UltyModalWrapperContext } from '../../../Shared/UltyModalWrapper/UltyModalWrapperContext'
import { useTranslation } from 'react-i18next'

const Container = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;

    & > div > div > span:last-of-type {
        font-size: .8em;
        line-height: 1.2em;
    }
`

const Title = styled.h4`
    text-align: center;
    :first-of-type {
        margin-top: .5rem;
    }
`

const DefinePickupTime = ({onSubmit}) => {
    const [t] = useTranslation()
    const [delayPickupTimeMinutes, setDelayPickupTimeMinutes] = useState(30)
    const {handleUltyModalWrapper} = useContext(UltyModalWrapperContext)

    return (
      <>
          <Title>{t('order.pickup_time.define_pickup_time_delay')}</Title>
          <Container>
              <UltyInputStep
                value={delayPickupTimeMinutes}
                step={10}
                min={0}
                max={50}
                unitLabel={t('order.pickup_time.units')}
                onChange={(value) => setDelayPickupTimeMinutes(value)}
              />
          </Container>

          <div style={{textAlign: 'right', marginTop: '10px'}}>
              <Button
                color="teal"
                fluid
                onClick={() => {
                    onSubmit(delayPickupTimeMinutes)
                    handleUltyModalWrapper(false, null)
                }}
              >
                  <Icon name="checkmark"/>
                  {t('global.validate')}
              </Button>
          </div>
      </>
    )
}

export default DefinePickupTime
